export default {
  messageList: [],
}
